import timeService from "../../../services/time/timeService"
import { confirmedExtensionPattern } from "../../../Helpers/Bookings/bookingHelpers"
export type BookingLinkedServiceCategory = 'remoteLock' | 'extendStay' | 'lateCheckOut' | 'earlyCheckIn' | 'parking'

export const bookingLinkedServiceCategories: { key: BookingLinkedServiceCategory, label: string }[] = [
  { key: 'remoteLock', label: 'Remote Lock' },
  { key: 'extendStay', label: 'Extend Stay' },
  { key: 'lateCheckOut', label: 'Late Check-Out' },
  { key: 'earlyCheckIn', label: 'Early Check-In' },
  { key: 'parking', label: 'Parking' },
]

// Entry names encode their payload, e.g. `parking-<bukibleId>-<bukinId>`, so match by prefix.
export const bookingLinkedServiceCategory = (name?: string): BookingLinkedServiceCategory | null => {
  if (!name) return null
  if (name === 'remoteLock') return 'remoteLock'
  if (confirmedExtensionPattern.test(name)) return 'extendStay'
  if (name.startsWith('lateCheckOut-')) return 'lateCheckOut'
  if (name.startsWith('earlyCheckIn-')) return 'earlyCheckIn'
  if (name.startsWith('parking-')) return 'parking'
  return null
}

// Rebuilds the entry name from the edited payload so the name and payload stay in sync.
export const bookingLinkedServiceName = (currentName: string, payload: any) => {
  const category = bookingLinkedServiceCategory(currentName)
  if (category === 'lateCheckOut' || category === 'earlyCheckIn') {
    return `${category}-${payload.timeDifference}`
  }
  if (category === 'parking') {
    return `parking-${payload.bukibleId}-${payload.bukinId}`
  }
  return currentName
}

export const parseLinkedServicePayload = (entry: any) => {
  try {
    return entry?.linkedServiceId ? JSON.parse(entry.linkedServiceId) : {}
  } catch (e) {
    return {}
  }
}

export const describeBookingLinkedService = (entry: any) => {
  const category = bookingLinkedServiceCategory(entry?.linkedService)
  const payload = parseLinkedServicePayload(entry)
  const format = (value: any) => value ? timeService.getFormattedTime(value) : '?'

  switch (category) {
    case 'extendStay':
      return `Extend Stay - new check-out ${format(payload.newCheckOut)}`
    case 'parking':
      return `Parking - ${format(payload.parkingStart)} to ${format(payload.parkingEnd)}`
    case 'lateCheckOut':
      return `Late Check-Out - ${payload.timeDifference ?? '?'} hour(s)`
    case 'earlyCheckIn':
      return `Early Check-In - ${payload.timeDifference ?? '?'} hour(s)`
    default:
      return entry?.linkedService || 'Linked Service'
  }
}
